import { useState } from 'react'

export interface ThumbnailBaseResponse<TData> {
    loading: boolean
    error?: Error
    data?: TData
}

export interface GetVimeoThumbnailUrlProps {
    url: string
    mediaId: string
}

export interface VimeoResponse {
    thumbnail_url: string
    mediaId?: string
}
/*
 * original interface
 * [
 *     (props: GetVimeoThumbnailUrlProps) => Promise<void>,
 *     ThumbnailBaseResponse<VimeoResponse>
 * ]
 * Replace type any with above when bug below is closed/merged
 * https://github.com/facebook/create-react-app/issues/9515
 */
const useVimeoThumnbailUrl = (): any => {
    const [loading, setLoading] = useState<boolean>(false)
    const [error, setError] = useState<Error>()
    const [data, setData] = useState<VimeoResponse>()

    const getVimeoThumbnailUrl = async ({
        url,
        mediaId,
    }: GetVimeoThumbnailUrlProps): Promise<void> => {
        setLoading(true)
        const vimeoResponse = await fetch(
            `https://vimeo.com/api/oembed.json?url=${encodeURI(url)}`
        ).catch((err: Error) => {
            setLoading(false)
            setError(err)
            return null
        })

        if (!vimeoResponse) return

        const vimeoResponseData = (await vimeoResponse
            .json()
            .catch((err: Error) => {
                setLoading(false)
                setError(err)
                return null
            })) as VimeoResponse | null
        if (!vimeoResponseData) return

        vimeoResponseData.mediaId = mediaId
        setLoading(false)
        setData(vimeoResponseData)
    }

    return [
        getVimeoThumbnailUrl,
        {
            loading,
            error,
            data,
        },
    ]
}

export default useVimeoThumnbailUrl
